import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Heading6, SmallText } from '../styleguide'
import formatDateTime from '../utils/formatDateTime'

const styles = {
  containerStyle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
}

const Podcasts = ({
  date,
  title,
  description,
  classes
}) => {
  const [formattedDate] = formatDateTime(date)

  return (
    <div className={classes.containerStyle}>
      <SmallText>
        {formattedDate}
      </SmallText>
      <Heading6 gutterBottom>{title}</Heading6>
      <SmallText>{description}</SmallText>
    </div>
  )
}

export default withStyles(styles)(Podcasts)



// WEBPACK FOOTER //
// ./src/components/PodcastsContent.js